import { useQuery } from "@tanstack/react-query";

import {
  AdminSellerDocument,
  type AdminSellerQuery,
} from "@/graphql/generated";
import { adminGqlRequest } from "@/lib/graphql";

export type AdminSeller = NonNullable<AdminSellerQuery["adminSeller"]>;

export function useAdminSeller(id: string) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["adminSeller", id],
    queryFn: async () =>
      (await adminGqlRequest<AdminSellerQuery>(AdminSellerDocument, { id }))
        .adminSeller ?? null,
  });
  return {
    seller: data ?? null,
    loading: isPending,
    failed: isError,
    notFound: data === null,
  };
}
